import type { ValidationCode, ValidationIssue } from '../domain/validators.js';
import { t } from '../features/i18n/index.js';

// Where → what is wrong → what to do; no developer vocabulary («формат ГГГГ-ММ», «неизвестный тип»).
const MESSAGES: Record<ValidationCode, string> = {
  principal_positive: 'Укажите сумму кредита.',
  term_positive: 'Укажите срок кредита.',
  term_too_long: 'Срок кредита не может быть больше 50 лет.',
  rate_invalid: 'Ставка не может быть отрицательной.',
  repayment_type: 'Выберите тип платежа.',
  strategy: 'Выберите, что уменьшают досрочные платежи: срок или платёж.',
  start_date: 'Укажите месяц первого платежа.',
  calculation_mode: t('bank.modeError'),
  bank_calendar: t('bank.error'),
  rate_period_range: 'Льготная ставка: конец периода раньше начала.',
  rate_period_rate: 'Льготная ставка не может быть отрицательной.',
  rate_periods_overlap: 'Льготные периоды пересекаются — сдвиньте один из них.',
  rate_period_beyond_term: 'Льготная ставка начинается после конца кредита — сдвиньте дату.',
  refinance_month: 'Рефинансирование возможно со второго месяца кредита.',
  refinance_rate: 'Новая ставка не может быть отрицательной.',
  refinance_term: 'Укажите новый срок после рефинансирования.',
  refinance_repayment_type: 'Выберите тип платежа после рефинансирования.',
  refinance_duplicate: 'Два рефинансирования в одном месяце — оставьте одно.',
  refinance_beyond_term: 'Рефинансирование позже конца кредита — сдвиньте дату.',
  overpayment_month: 'Досрочный платёж не может быть раньше первого платежа.',
  overpayment_beyond_term: 'Досрочный платёж позже конца кредита — сдвиньте дату.',
  overpayment_amount: 'Досрочный платёж: укажите сумму в целых рублях.',
  overpayment_amount_zero: 'Укажите сумму досрочного платежа.',
  overpayment_strategy: 'Выберите, что уменьшают досрочные платежи: срок или платёж.',
  overpayment_exclusive: 'Выберите один способ: одинаковая сумма или до общей суммы в месяц.',
  recurring_step: 'Регулярные досрочные платежи можно повторять только каждый месяц.',
  recurring_end: 'Досрочные платежи: последний месяц раньше первого.',
  adaptive_step: 'Регулярные досрочные платежи можно повторять только каждый месяц.',
  adaptive_target: 'Укажите общий платёж в месяц.',
  adaptive_min: 'Минимум досрочно не может быть отрицательным.',
  adaptive_min_exceeds_target: 'Минимум досрочно больше общего платежа — уменьшите минимум или увеличьте общий платёж.',
  adaptive_end: 'Досрочные платежи: последний месяц раньше первого.',
  schedule: 'С такими параметрами график не сходится. Проверьте ставку, срок и досрочные платежи.',
  shape: 'Данные сценария повреждены — открыть его нельзя. Создайте сценарий заново.',
};

/** Russian text for a validation issue; falls back to the English reference message. */
export function describeIssue(issue: ValidationIssue): string {
  return MESSAGES[issue.code] ?? issue.message;
}

/**
 * Writes store validation errors (one line each, via textContent) into `#form-errors`
 * and toggles its visibility. Accepts localisable issues or plain strings.
 * No-op when the container is missing.
 */
export function renderFormErrors(
  errors: ReadonlyArray<string | ValidationIssue>,
  container: HTMLElement | null = document.getElementById('form-errors'),
): void {
  if (!container) return;
  const texts = Array.from(new Set(errors.map(e => (typeof e === 'string' ? e : describeIssue(e)))));
  const lines = texts.map(text => {
    const line = document.createElement('p');
    line.textContent = text;
    return line;
  });
  container.replaceChildren(...lines);
  container.hidden = errors.length === 0;
}

